(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-detail-navigation"]) return;
  try {
    
  document.body.classList.add('hide-nav-on-scroll-up');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-extended"] && !window.DesignMode) return;
  try {
    

  class ImageBannerParallax extends HTMLElement {
    constructor() {
      super();
      // "Parallax" effect for banner images
      this.imageToMoveForeground = this.querySelector('[data-image-banner-image-foreground]');
      this.imageToMoveBackground = this.querySelector('[data-image-banner-image-background]');
      this.moving = false;

      if (this.imageToMoveForeground && this.imageToMoveBackground) {
        this.imageToMoveForeground.style.transition = 'transform .75s linear';
        this.imageToMoveBackground.style.transition = 'transform .75s linear';

        this.addEventListener("mousemove", this.moveImage, false);
        this.addEventListener("mouseleave", function() {
          // reset
          this.imageToMoveForeground.style.transform = 'translate(0,0)';
          this.imageToMoveBackground.style.transform = 'translate(0,0)';
          this.imageToMoveForeground.style.transition = 'transform .75s linear';
          this.imageToMoveBackground.style.transition = 'transform .75s linear';
          this.moving = false
        });
      }
    }

    moveImage(e) {
      if (!this.moving) {
        this.imageToMoveForeground.style.transition = 'transform .5s linear';
        this.imageToMoveBackground.style.transition = 'transform .5s linear';
      }
      this.moving = !this.moving;
      const valueForeground = (e.pageY / 12);
      const valueBackground = (e.pageY / 24);
      this.imageToMoveForeground.style.transform = `translateY(${valueForeground}px)`;
      this.imageToMoveBackground.style.transform = `translateY(${valueBackground}px)`;
    }
  }
  customElements.define('image-banner-parallax', ImageBannerParallax);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  if (document.querySelector('.newsletter-section')) {
    if (blogPage.showNewsletterFirstOnly && blogPage.currentPage === 1 || !blogPage.showNewsletterFirstOnly) {
      const newNewsletter = document.querySelector('.newsletter-section');
      newNewsletter.classList.add('main-blog__newsletter','is-col-12', 'is-col-10-lg','grid-col-start-2-lg');
      newNewsletter.querySelector('.contact-block__wrapper').classList.remove('is-col-10-lg','has-col-10-lg','grid-col-start-2-lg');
      newNewsletter.style.gridRow = 2;
      document.querySelector('[data-blog-grid').append(newNewsletter);
    }
    else {
      document.querySelector('.newsletter-section').remove();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.body.classList.add('hide-nav-on-scroll-up');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text-extended"] && !window.DesignMode) return;
  try {
    
  class RichTextParallax extends HTMLElement {
    constructor() {
      super();
      // "Parallax" effect for banner images
      this.imageToMoveForeground = this.querySelector('[data-image-banner-image-foreground] figure');
      this.imageToMoveBackground = this.querySelector('[data-image-banner-image-background]');
      this.moving = false;

      if (this.imageToMoveForeground && this.imageToMoveBackground) {
        this.imageToMoveForeground.style.transition = 'transform .75s linear';
        this.imageToMoveBackground.style.transition = 'transform .75s linear';

        this.addEventListener("mousemove", this.moveImage, false);
        this.addEventListener("mouseleave", function() {
          // reset
          this.imageToMoveForeground.style.transform = 'translateY(-50%)';
          this.imageToMoveBackground.style.transform = 'translateY(0)';
          this.imageToMoveForeground.style.transition = 'transform .75s linear';
          this.imageToMoveBackground.style.transition = 'transform .75s linear';
          this.moving = false
        });
      }
    }

    moveImage(e) {
      if (!this.moving) {
        this.imageToMoveForeground.style.transition = 'transform .5s linear';
        this.imageToMoveBackground.style.transition = 'transform .5s linear';
      }
      this.moving = !this.moving;
      this.imageToMoveForeground.style.transform = `translateY(-55%)`;
      this.imageToMoveBackground.style.transform = `translateY(10px)`;
    }
  }
  customElements.define('rich-text-parallax', RichTextParallax);

  } catch(e) { console.error(e); }
})();
})();
